


const state = {
    cartItems: [],
    cartTotal: 0
  }
  const mutations = {
    setSearchTerm (state, data) {
      state.userSearch = data
    },
    SET_INITIAL_CART(state, prodInfo){
        state.cartTotal  = state.cartTotal + Number(prodInfo.prodPrice)
        state.cartItems.push(prodInfo.prodDesc)
    },
    updateTotalPrice(state, cartItemUpdate){

      //Find index of specific object using findIndex method.    
      const cartItemIndex = state.cartItems.findIndex((oldItem => oldItem.title == cartItemUpdate.itemTitle));
      //Update object's name property.
      state.cartItems[cartItemIndex].totalPrice = cartItemUpdate.itemTotal
          },
    removeItemFromCart(state, cartItemTitle){
      //Find index of specific object using findIndex method.    
      const cartItemIndex = state.cartItems.findIndex((oldItem => oldItem.title == cartItemTitle));
      state.cartItems.splice(cartItemIndex, 1);
    },
    addNewItem(state, cartItem){
      state.cartItems.push(cartItem)
      
    }
  }
  const actions = {
    cartUpdate({commit, state}, prodInfo){
        const productsExisting = state.cartItems
        console.log('Setting the cart', prodInfo.prodDesc)
        
        commit('SET_INITIAL_CART', prodInfo)
        
    }
  }
  const getters = {
    cartItems: state => {
      return state.cartItems
    },
    cartTotal (state) {
      const arrayOfTotals = state.cartItems.map(item => item.totalPrice);
      return arrayOfTotals.reduce((a, b) => Number(a) + Number(b))
      }
  }
  
  export default {
    state,
    actions,
    getters,
    mutations
  }
  


// WEBPACK FOOTER //
// ./src/store/modules/cart.js